import { IQueryTypeFragments } from '../../QueryFragments';
import { QueryType } from '../Default';

const usageOptionsFragment = `
    on ${QueryType.product} {
        usage_options {
            key
            value
        }
    }
`;

export const usageOptionsFragments = (): IQueryTypeFragments => {
    return {
        [QueryType.product]: usageOptionsFragment
    };
};
